import React from 'react';
import type { RunnerCapabilityCoverage } from '@api/localRunners';
import type { AssigneeType } from '@api/processes';
import { HintRow, HintText } from './CapabilityHint.styled';
import { resolveCoverageHint } from './resolveCoverageHint';

export interface CapabilityHintProps {
  readonly coverage: RunnerCapabilityCoverage | undefined;
  readonly assigneeType: AssigneeType;
  readonly agentLabel: string;
  readonly nodeId: string;
}

const CapabilityHint: React.FC<CapabilityHintProps> = ({
  coverage,
  assigneeType,
  agentLabel,
  nodeId,
}) => {
  const hint = resolveCoverageHint(coverage, assigneeType, agentLabel);
  if (!hint) return null;
  return (
    <HintRow $tone={hint.tone} data-testid={`process-node__capability-hint-${nodeId}`}>
      <span className="material-symbols-rounded" aria-hidden="true">
        {hint.tone === 'warn' ? 'warning' : 'check_circle'}
      </span>
      <HintText>{hint.text}</HintText>
    </HintRow>
  );
};

export default CapabilityHint;
